export const TRANSITION = '@@router/TRANSITION';

function transition(method, args) {
  return {
    type: TRANSITION,
    payload: {
      method,
      args
    }
  };
}

export const routeActions = {
  push: (...args) => transition('push', args),
  replace: (...args) => transition('replace', args),
  go: (...args) => transition('go', args),
  goBack: (...args) => transition('goBack', args),
  goForward: (...args) => transition('goForward', args)
};

export const push = (...args) => routeActions.push(...args);
export const replace = (...args) => routeActions.replace(...args);
export const go = (...args) => routeActions.go(...args);
export const goBack = (...args) => routeActions.goBack(...args);
export const goForward = (...args) => routeActions.goForward(...args);
